// @ts-nocheck
// Greif UI Kit = line-document
import React from "react";

const DocumentLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M14 8h3.586L14 4.414zm7 12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h7a1 1 0 0 1 .707.293l7 7A1 1 0 0 1 21 9zM5 20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V10h-6a1 1 0 0 1-1-1V3H6a1 1 0 0 0-1 1z"
            />
        </svg>
    );
};

export default React.memo(DocumentLine);
